@if(phoneAuthorized){
<div class="tw-flex tw-flex-wrap tw-items-center tw-justify-center tw-gap-2">
  <label><i class="pi pi-check text-success"></i> Phone Saved </label>
  [{{phoneNumber}}]
</div>
}
@else {
<form #phoneForm="ngForm" novalidate class="p-fluid tw-w-full tw-space-y-1">
  <div class="uw-message uw-warning">
    <strong>Note:</strong> For checkout we need your mobile phone number.
  </div>
    <mat-form-field>
    <mat-label>Mobile Phone</mat-label>
    <input matInput [(ngModel)]="phoneNumber" name="phone" required pattern="{{phonePattern}}" />
    <span matTextPrefix>+44&nbsp;</span>
    @if(phoneNumber && !phoneNumber.match('^(0?\d{10})$')) {
    <mat-error>Please enter valid UK phone number</mat-error>
    }
    <mat-hint>We will use this number to contact you about your order</mat-hint>
  </mat-form-field>
  <div class="tw-text-center">
    <button mat-flat-button [disabled]="busy || phoneForm.invalid" (click)="saveMobilePhone()">
      <mat-icon>check</mat-icon>
      Continue
    </button>
  </div>
  <div class="field col-12">
    <div class="text-danger">{{error?.message}}</div>
  </div>
</form>
}